import { z } from 'zod';
import { parseCalendarDate } from '@klothiq/domain';

export const workDateSchema = z
  .string()
  .refine((value) => !!parseCalendarDate(value), 'Enter a valid calendar date.')
  .nullable();
export const workChecklistSchema = z
  .array(
    z
      .object({
        id: z.string().min(1).max(64),
        text: z
          .string()
          .min(1)
          .max(160)
          .refine((text) => text.trim().length > 0, 'Enter a checklist step.'),
        done: z.boolean(),
      })
      .strict(),
  )
  .max(30)
  .refine(
    (items) => new Set(items.map((item) => item.id)).size === items.length,
    'Checklist entries must have unique IDs.',
  );
export const workPrioritySchema = z.enum(['low', 'normal', 'high', 'urgent']);
export const workPlanSchema = z
  .object({
    title: z.string().trim().min(3).max(120),
    description: z.string().trim().max(2000).nullable(),
    goal: z.string().trim().max(500).nullable(),
    start_date: workDateSchema,
    target_date: workDateSchema,
    priority: workPrioritySchema,
  })
  .refine(
    (input) => !input.start_date || !input.target_date || input.target_date >= input.start_date,
    { path: ['target_date'], message: 'Target date cannot be earlier than the start date.' },
  );
export const workTaskDetailsSchema = z.object({
  title: z.string().trim().min(3).max(160),
  description: z.string().trim().max(4000).nullable(),
  priority: workPrioritySchema,
  due_date: workDateSchema,
  checklist: workChecklistSchema,
});
